
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#4A4A4A","fill":"#FFF","fill-rule":"nonzero","d":"M16.5 7.5L23 3.714h2.5L28.5 5 30 6.286 25.5 36.07 24 36.5l-1-.429z"}}),_c('ellipse',{attrs:{"stroke":"#4A4A4A","cx":"24","cy":"42.5","rx":"3","ry":"2.5"}}),_c('path',{attrs:{"fill":"#64C7C3","fill-rule":"nonzero","d":"M18 8.5l6 27v-30z"}}),_c('path',{attrs:{"d":"M22.347 41.5c-.14.54-.14 1.04 0 1.5.153.5.689 1 1.153 1 .208 0 .59.101 1 0 .574-.142 1.158-.5 1-.5-.5 0-1.496-.043-2.153-.5-.42-.293-.409-.474-.5-1-.082-.474.638-.862.5-1-.075-.075-.408.092-1 .5z","stroke":"#64C7C3","stroke-width":".5","fill":"#64C7C3","fill-rule":"nonzero"}})])])
          )
        }
      }
    